import React from "react";
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";
import { getCountryName } from "../../../utils/constants/nameCountry";
import createPNUDTitle from "../../../utils/functions/createPNUDTitle";
import TEXT from "../../../utils/text/pnudBook.json";
import SurveyGraphSection from "../../reusable/SurveyGraphSection/SurveyGraphSection";
import DATA from "../../../utils/PNUD/socialServices.json";
import "./PNUDSocialServices.css";
import CardSurveys from "../../reusable/CardSurveys";
import { TOOLTIP_STYLE } from "../../../utils/constants/graphConfigs";

export default function PNUDSocialServices({ textPlacement }) {
  const { language } = useCurrentLanguage();

  function SocialServicesGraph() {
    const options = {
      color: ["#6a7fa1", "#253c59", "#bf8d30"],
      tooltip: {
        ...TOOLTIP_STYLE,
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        valueFormatter: (value) => value + "%",
      },
      legend: {},
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      xAxis: {
        type: "value",
        axisLabel: {
          formatter: "{value}%",
        },
      },
      yAxis: {
        type: "category",
        data: DATA["countries"]
          .map((e) => getCountryName(e, language, true))
          .reverse(),
      },
      series: [
        {
          name: "Control",
          type: "bar",
          data: DATA["control"].reverse(),
        },
        {
          name: "Informativo",
          type: "scatter",
          data: DATA["informative"].reverse(),
        },
        {
          name: "Emotivo",
          type: "scatter",
          symbol: "triangle",
          data: DATA["emotive"].reverse(),
        },
      ],
    };

    return (
      <>
        <div className="pnud-graph-content">
          <CardSurveys options={options} isGraphLeft={true} />
        </div>
        <div className="pnud-graph-note">{TEXT["notePercentage"][language]}</div>
      </>
    );
  }

  return (
    <SurveyGraphSection
      graphID={"pnud-acceptance"}
      textPlacement={textPlacement}
      title={createPNUDTitle(TEXT["socialServices"]["title"], language)}
      description={TEXT["socialServices"]["description"][language]}
      language={language}
      graphComponent={<SocialServicesGraph />}
      source={TEXT["source"][language]}
    />
  );
}
